module.exports = __webpack_public_path__ + "static/img/06.2d03ecf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partner/06.png
// module id = X/ti
// module chunks = 1